import EditUser from "@/apsales/Users/Edit";

export default function AddUser() {
    return <EditUser mode="add" />;
}